import { ModelFilter } from "@react3l/react3l/core";
import { IdFilter, StringFilter } from "@react3l/advanced-filters";

export class DurationFilter extends ModelFilter {
  public id?: IdFilter = new IdFilter();
  public name?: StringFilter = new StringFilter();
}
